import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

import { FileDropzoneComponent } from '../file-dropzone/file-dropzone.component';
import { ZipService } from '../services/zip.service';
import { DownloadService } from '../services/download.service';
import { FileIconComponent } from '../file-icon/file-icon.component';

@Component({
    selector: 'ell-file-list',
    standalone: true,
    imports: [FileDropzoneComponent, FileIconComponent, FontAwesomeModule],
    templateUrl: './file-list.component.html',
    styleUrl: './file-list.component.scss'
})
export class FileListComponent {
    faDownload = faDownload;

    @Input()
    allowDelete = false;

    @Input()
    readonly = false;

    @Input()
    files?: File[] | null = [];

    @Output()
    addFiles = new EventEmitter<File[]>();

    @Output()
    deleteFile = new EventEmitter<File>();

    constructor(private downloadService: DownloadService, private zipService: ZipService) {
    }

    delete(file: File) {
        this.deleteFile.next(file);
    }

    async download(file?: File) {
        if (!file) {
            const zip = await this.zipService.zip(this.files!);
            file = new File([new Blob([zip])], "files.zip");
        }

        this.downloadService.download(file);
    }
}
